import { useQuery } from 'react-query';
import { iteroCartService } from 'services';
import { ServerStateKeysEnum } from '../../constants';

export const useRetriveITeroCart = () => {
  return useQuery(
    `${ServerStateKeysEnum.userIteroCart}`,
    () => {
      return iteroCartService.createITeroCart();
    },
    {
      staleTime: Infinity,
    }
  );
};
